import { getConfigJson as getConfigJsonApi } from "@/plugins/api";
import Message from "@/components/Message";

/*
 * @desc 更新版本。通过对比服务端与客户端的版本号判断是否需要更新
 */
export async function updateVersion() {
  if(process.env.NODE_ENV !== "production") return;
  const configJson = await getConfigJsonApi();
  const serviceVersion = configJson.version; //服务端版本号
  const clientVersion = document
    .querySelector("#config")
    .content.split(",")
    .find((item) => item.includes("version="))
    .split("=")[1]; //客户端版本号
  if (serviceVersion && serviceVersion !== clientVersion) {
    Message.success("正在自动升级新版本...");
    setTimeout(() => window.location.reload(), 2000); // 版本不同 刷新 获取最新版本
  }
}
